var app = angular.module('leonardo');

var ZendeskService = function ($window, $document, $q) {
  var service = {};

  var scriptLoaded = false;

  service.load = function () {
    if ($window.zE) {
      zE('messenger', 'show');
      return $q.resolve(); 
    }
    if (scriptLoaded) return $q.resolve();
    var deferred = $q.defer();

    var script = $document[0].createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=8c2fbb7b-badc-4cdb-9d7f-80378921233a';
    script.async = true;
    script.onload = function () {
      scriptLoaded = true;
      deferred.resolve();
    };

    script.onerror = function () {
      deferred.reject('Zendesk script failed to load');
    };

    $document[0].body.appendChild(script);

    return deferred.promise;
  };


  service.remove = function () {
    if (!$window.zE) return;
    zE(function () {
      zE('messenger', 'resetWidget');
      zE('messenger', 'hide'); 
    });
  };

  return service;
};

app.factory('ZendeskService', ['$window', '$document', '$q', ZendeskService]);
